import React from 'react'
import { Card, Image, Grid } from 'semantic-ui-react'
import MediaButton from '../../../../MediaButton'

const Images = ({ obj, onChange }) => {

  const img_desktop = obj.img_desktop ? obj.img_desktop : null
  const img_mobile = obj.img_mobile ? obj.img_mobile : null

  const onClick = (e, media, language, id, type) => {
    onChange(e, { id, value: media.file }, 'image')
  }

  return (
    <div>
      <Grid columns={4}>
        <Grid.Row>
          <Grid.Column>
            <Card fluid>
              { img_desktop && typeof img_desktop === 'string' && <Image src={img_desktop} /> }
              <Card.Content>
                <MediaButton fluid={true} icon='upload' label='Image (Desktop)' id='img_desktop' handleClick={onClick}></MediaButton>
              </Card.Content>
            </Card>
          </Grid.Column>
          <Grid.Column>
            <Card fluid>
              { img_mobile && typeof img_mobile === 'string' && <Image src={img_mobile} /> }
              <Card.Content>
                <MediaButton fluid={true} icon='upload' label='Image (Mobile)' id='img_mobile' handleClick={onClick}></MediaButton>
              </Card.Content>
            </Card>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </div>
  )
}

export default Images



// WEBPACK FOOTER //
// ./src/components/form/pageBuilder/blocks/content/images.js